export default {
  seoTitle: "한국고무공업주식회사 - 산업용 고무제품 · 맞춤형 고무성형 · 압축성형 전문 제조기업",
  hero: {
    badge: "Since 1975 · Engineering Partner",
    headline1: "고무제품에",
    headline2: "문제가 있으신가요?",
    subtitle: "50년 이상의 기술력으로 고객의 문제를 해결합니다. 도면이 없어도 괜찮습니다. 함께 분석하고, 함께 만들어 드립니다.",
    ctaInquiry: "제품 문의하기",
    ctaAbout: "회사 소개 보기",
    scroll: "Scroll",
    stats: [
      { label: "Years of Experience", value: "50+" },
      { label: "Industries Served", value: "20+" },
      { label: "Custom Products", value: "1,200+" },
      { label: "Quality Pass Rate", value: "99.7%" },
    ],
  },
  quickContact: {
    message: "고무제품에 문제가 있으신가요? 저희가 해결해 드리겠습니다.",
    quoteRequest: "견적 요청",
  },
  aboutPreview: {
    eyebrow: "About Us",
    headline1: "고객의 문제를 해결하는",
    headline2: "기술 중심 제조기업",
    desc: "한국고무공업주식회사는 다양한 산업 분야의 고무제품을 개발·생산하며, 고객이 겪는 기술적인 문제를 함께 분석하고 해결책을 제시하는 기술 파트너입니다. 단순한 제조를 넘어 컨설팅 가능한 엔지니어링 회사를 지향합니다.",
    stats: [
      { num: "50+", label: "Years\nof Heritage" },
      { num: "1,200+", label: "Custom\nProjects" },
      { num: "ISO", label: "Quality\nManagement" },
    ],
    detailBtn: "자세히 보기",
    productsBtn: "제품 라인업",
    floatingTitle: "50년간 쌓아온\n엔지니어링 신뢰",
    badge: "Verified Manufacturer",
  },
  quality: {
    eyebrow: "Quality & Technology",
    title: "품질과 기술력으로 증명하는 신뢰",
    desc: "50년간 축적된 압축성형 기술과 엄격한 품질관리 시스템으로 고객이 신뢰할 수 있는 제품을 공급합니다.",
    cards: [
      { icon: "ri-shield-check-line", title: "ISO 9001 / IATF 16949", desc: "국제 품질경영시스템 인증으로 일관된 품질 보증" },
      { icon: "ri-flask-line", title: "연구개발전담부서", desc: "KOITA 인증 기업부설연구소 운영, 지속적 기술 혁신" },
      { icon: "ri-building-2-line", title: "2,000㎡ 생산시설", desc: "50톤~1300톤 프레스 30기, 자체 혼련 라인 보유" },
      { icon: "ri-global-line", title: "SINCE 1975", desc: "50년 이상의 업력" },
    ],
  },
  strengths: {
    eyebrow: "Core Strengths",
    headline1: "제품이 아니라",
    headline2: "해결책을 만드는 회사",
    desc: "설계부터 양산까지 일관된 프로세스로, 고객사의 까다로운 요구도 한 번에 맞춰드립니다. 40년 노하우가 만든 차이입니다.",
    items: [
      { no: "01", icon: "ri-tools-line", title: "맞춤형 고무제품 개발", desc: "고객의 요구사항을 분석하여 도면 설계부터 시제품 제작까지 원스톱으로 진행합니다.", tag: "Custom Design" },
      { no: "02", icon: "ri-settings-3-line", title: "산업용 고무 부품 제조", desc: "자동차, 전자, 건설, 중공업 등 다양한 산업 분야의 정밀 고무 부품을 양산합니다.", tag: "Industrial" },
      { no: "03", icon: "ri-stack-line", title: "압축성형 전문", desc: "50년간 축적된 압축성형 기술로 고품질 고무제품을 안정적으로 제조합니다.", tag: "Compression" },
      { no: "04", icon: "ri-pencil-ruler-2-line", title: "금형 개발 협력", desc: "전문 금형 파트너사와의 협업으로 복잡한 형상의 제품도 정확하게 구현합니다.", tag: "Tooling" },
      { no: "05", icon: "ri-line-chart-line", title: "소량~대량 생산 가능", desc: "시제품 1개부터 월 100만개 양산까지, 고객의 수량 요구에 유연하게 대응합니다.", tag: "Flexible MOQ" },
      { no: "06", icon: "ri-shield-check-line", title: "품질관리 및 기술지원", desc: "ISO 기반 품질관리 체계와 전담 엔지니어의 사후 기술지원을 제공합니다.", tag: "Quality" },
    ],
  },
  latestProducts: {
    eyebrow: "Latest Products",
    title: "주요 제품",
    desc: "자동차부터 중공업까지, 다양한 산업 현장에 공급되는 한국고무공업의 대표 제품을 만나보세요.",
    viewAll: "전체 제품 보기",
    quoteRequest: "견적 요청",
    detail: "상세 보기",
  },
  noticesTech: {
    noticeEyebrow: "Notice",
    noticeTitle: "최근 공지사항",
    techEyebrow: "Technical",
    techTitle: "최근 기술자료",
    viewAll: "전체보기",
    important: "중요",
    emptyNotices: "등록된 공지사항이 없습니다.",
    emptyTech: "등록된 기술자료가 없습니다.",
  },
  cta: {
    eyebrow: "Solution Inquiry",
    headline1: "고무제품 때문에",
    headline2: "고민하고 계신가요?",
    desc: "도면이 없어도 괜찮습니다. 사진 한 장, 샘플 하나만 보내주시면 저희 엔지니어가 함께 분석하고 해결책을 찾아드립니다.",
    contactBtn: "문의하기",
    quickContact: "Quick Contact",
    phone: "Phone",
    email: "Email",
    hours: "Business Hours",
    hoursValue: "평일 09:00 - 18:00",
  },
};